export default {
  forum: {
    post: {
      title: "论坛"
    },
    proposition: {
      title: "提案",
      list: {
        empty: "读取中",
        header: {
          proposition: "提案",
          voteCount: "投票数量"
        }
      }
    }
  }
}
